<template>
  <!-- 客户标签 -->
  <div class="customersTag">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">新增客户标签</el-button>
      </template>
    </page-header>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入关键字" v-model="searchForm.name"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column label="序号" align="center">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort_id" label="排序" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="title" label="客户标签" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" style="padding:2px 3px;" plain @click="handleAdd(scope.row)">编辑</el-button>
          <el-button type="danger" style="padding:2px 3px;" plain @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>

    <!-- 客户标签弹窗 -->
    <el-drawer
      :visible.sync="isCustomersTag"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl">
      <div class="drawer-header">客户标签</div>
      <el-scrollbar style="height:calc(100% - 90px);">
        <div class="drawer-form-wrap">
          <el-form :model="addForm" label-position="rigth" label-width="120px" :rules="addFormRule" ref="addForm">
            <el-form-item label="客户标签" prop="title">
              <el-input v-model="addForm.title"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort_id">
              <el-input v-model="addForm.sort_id"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js"

export default {
  name: 'customersTag',
  data() {
    return {
      /**表格数据 */
      tableData:[],
      /**搜索表单 */
      searchForm:{
        name: ''
      },
      /**分页数据 */
      currPage:1,
      pageSize:20,
      allPage:0,
      isCustomersTag: false,  
      addForm: {
        sort_id: '',
        title: '',
        id: '',
      },
      addFormRule: {
        name: [mustFill]
      }
    }
  },
  mounted() {
    this.getTableData()
  },
  methods:{
    /**返回 */
    goBack() {
      this.$router.go(-1)
      this.$destroy()
    },
    /**获取表格数据 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      let data = {
        entId: window.localStorage.getItem("entId"),
        id: '',
        channel_id: 21, //客户标签
        title: '',
        parent_id: '',
        class_layer: '',
        sort_id: '',
        link_url: '',
        img_url: '',
        pageIndex: this.currPage,
        pageSize: 20,
        toTal: '',
        sqlValue: this.searchForm.name,
        keyId: 0,
      };
      this.$request({
        method: 'post',
        url: 'Base/GetTableCategory',
        data: data,
      }).then(res => {
        console.log('获取数据',res);
        this.tableData = []
        this.allPage = 0
        if(res.success){
          this.allPage = res.toTal
          this.tableData = (res.list || []).map(item => ({
            id: item.Id, // 编号 
            channel_id: item.channel_id || 21 , // 客户标签编号
            title: item.title || '', // 客户标签名称
            sort_id: item.sort_id || '', // 排序
          }))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**刷新数据 */
    handleRefresh(){
      this.getTableData()
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val
      this.getTableData()
    },
    handleDel(row){
      console.log('删除行数据',row);
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          entId: window.localStorage.getItem('entId'),
          keyIdList: row.id,
        }
        this.$request({
          url: 'Base/DltTableCategory',
          method: "post",
          data: data
        }).then(res => {
          if (res.success) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.handleRefresh()
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      }).catch(() => {})
    },
    handleAdd(row) {
      console.log('row', row);
      this.clearForm()
      if (row ) {
        // 直接使用传入的 row 对象
        this.addForm = {
          id: row.id,
          title: row.title || '',
          sort_id: row.sort_id || '',
          channel_id: row.channel_id || 21
        };
        console.log('赋值后的 addForm:', JSON.stringify(this.addForm));
      } else {
        // 新增时重置表单
        this.addForm = {
          id: '',
          title: '',
          sort_id: '',
          channel_id: 21
        };
      }
      this.isCustomersTag = true
    },
    clearForm() {
      // for (let key in this.addForm) {
      //   this.addForm[key] = ''
      // }
      this.addForm = {
        id: '',
        title: '',
        sort_id: '',
        channel_id: 21,
      };
      this.isCustomersTag = false
    },
    submit() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          let data = {
            entId: window.localStorage.getItem('entId'),
            channel_id: 21,
            sort_id: this.addForm.sort_id || 0,
            title: this.addForm.title || '',
            id: this.addForm.id || 0,
          }
          console.log('提交的数据',data);
          this.$request({
            url: 'Base/SaveTableCategory',
            method: "post",
            data: data
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.clearForm()
              this.handleRefresh()
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.customersTag{
  width: 100%;
  height: 100%;
}
</style>
